
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Button, Image, ReviewsCard, Row, Section } from '../../importCL';
import { useWidthContext } from '../../providers/Width';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

import './ReviewsTricardModule.css';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';

interface IReviewsTricardModuleProps extends MappedComponentProperties {
    backgroundColor?: string;
    headlineText?: string;
    cardOneImagePath?: string;
    cardOneImageAltText?: string;
    cardOneHeadlineText?: string;
    cardOneDescriptionText?: string;
    cardOneLink?: string;
    cardOneLinkText?: string;
    cardTwoImagePath?: string;
    cardTwoImageAltText?: string;
    cardTwoHeadlineText?: string;
    cardTwoDescriptionText?: string;
    cardTwoLink?: string;
    cardTwoLinkText?: string;
    cardThreeImagePath?: string;
    cardThreeImageAltText?: string;
    cardThreeHeadlineText?: string;
    cardThreeDescriptionText?: string;
    cardThreeLink?: string;
    cardThreeLinkText?: string;
}

export const ReviewsTricardModuleEditConfig = {
    emptyLabel: 'Reviews Tricard Module',
    isEmpty: (props: PropsWithChildren<IReviewsTricardModuleProps>) => {
        return !props || !props.headlineText;
    },
};

const BACKGROUND_COLOR_OPTIONS = {
    purple: { backgroundColor: 'purple', titleColor: 'text-white' },
    blue: { backgroundColor: 'blue', titleColor: 'text-white' },
    lightGray: { backgroundColor: 'light-grey', titleColor: 'text-grey-tundora' },
    white: { backgroundColor: 'white', titleColor: 'text-grey-tundora' },
} as const;

const ReviewsTricardModule = (props: PropsWithChildren<IReviewsTricardModuleProps>): JSX.Element => {
    const { width } = useWidthContext();
    const sectionStyles = BACKGROUND_COLOR_OPTIONS[props?.backgroundColor ?? 'white'];
    const cardProps = [
        {
            imagePath: props.cardOneImagePath,
            imageAltText: props.cardOneImageAltText,
            headlineText: props.cardOneHeadlineText,
            descriptionText: props.cardOneDescriptionText,
            link: props.cardOneLink,
            linkText: props.cardOneLinkText,
        },
        {
            imagePath: props.cardTwoImagePath,
            imageAltText: props.cardTwoImageAltText,
            headlineText: props.cardTwoHeadlineText,
            descriptionText: props.cardTwoDescriptionText,
            link: props.cardTwoLink,
            linkText: props.cardTwoLinkText,
        },
        {
            imagePath: props.cardThreeImagePath,
            imageAltText: props.cardThreeImageAltText,
            headlineText: props.cardThreeHeadlineText,
            descriptionText: props.cardThreeDescriptionText,
            link: props.cardThreeLink,
            linkText: props.cardThreeLinkText,
        },
    ];

    const ReviewCardItem = (props: any) => {
        if (!props.imagePath) {
            return <></>;
        }

        return (
            <ReviewsCard cardVariant='news'
                topElement={<Image className='mb-6' src={props.imagePath as string} alt={props.imageAltText ?? 'image'} />}
                reviewContent={{
                    headLineText: (transformHTMLParserLinks(props.headlineText ?? '')),
                    bodyText: (transformHTMLParserLinks(props.descriptionText ?? '')),
                }}>
                <ButtonWrapper className='!p-0 !text-base underline !mb-0'
                    target={'_self'}
                    variant={'link'}
                    href={props.link}>
                    {transformHTMLParserLinks(props.linkText ?? 'Read More')}
                </ButtonWrapper>
            </ReviewsCard>
        );
    };

    const isDark = (props.backgroundColor === 'purple' || props.backgroundColor === 'blue');

    return (
        <Section className={`reviewsTricardModule ${isDark ? 'darkMode' : ''}`}
            containerClass='reviewsTricardModule__sectionContainer'
            bgColor={sectionStyles.backgroundColor}
            horizontalTitle
            titleClass={`justify-left ${isDark ? 'text-white' : ''}`}
            title={transformHTMLParserLinks(props.headlineText)}>
            <Row className={`flex justify-center gap-[1.5rem] ${width <= 768 ? 'flex flex-col' : ''}`}>
                {cardProps.map((cp, i) => (<ReviewCardItem key={i} {...cp} />))}
            </Row>
        </Section>
    );
};

export default ReviewsTricardModule;
 